<script setup lang="ts">
import { useFieldScope } from 'vince-ui/composables/useFieldScope';

const props = defineProps<{
    label: string;
    error?: string;
    hint?:string;
    labelFor?: string;
    required?: boolean
}>();

const trackFocusedField = useFieldScope(() => props.label);
</script>

<template>
    <VLIftaLabel @focusin="trackFocusedField">
        <slot />
        <label :for="labelFor">
            {{ label }}
            <span v-if="required" class="text-[var(--danger-color)]">*</span>
        </label>
        <VLMessage v-if="error" severity="error" size="small" variant="simple" class="ml-1 mt-1">
            {{ error }}
        </VLMessage>

        <VLMessage v-if="hint && !error" severity="primary" size="small" variant="simple" class="ml-1 mt-1">
            {{ hint }}
        </VLMessage>
    </VLIftaLabel>
</template>
